











































import { Vue, Component } from 'vue-property-decorator'
@Component({
    computed:{

        user () {
            return this.$store.getters.user
        },
        error () {
            return this.$store.getters.error
        }

    },
    watch: {
        user (value) {
            if (value !== null && value !== undefined) {
                
                if (value.role == 'USER')
                    this.$router.push('/myClass')
                else
                    this.$router.push('/');
            }
        },
        error ( value ){
            if (value !== null && value !== undefined) {
                // @ts-ignore
                this.text = value;
                // @ts-ignore
                this.snackbar = true
            }
        }
    }
})
export default class Login extends Vue{


       public usuario = {
            email:'',
            password:''
        };
        public  snackbar= false;
        public  text= '';


        login(){
            this.$store.dispatch('signUserIn', {
                email: this.usuario.email,
                password: this.usuario.password
            })
        }


}
